import { render, staticRenderFns } from "./totpLogin.vue?vue&type=template&id=10d47891&"
import script from "./totpLogin.vue?vue&type=script&lang=js&"
export * from "./totpLogin.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports